import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, Copy } from "lucide-react";
import { api } from "@/lib/api";

const eur = (n) => `${(n || 0).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €`;

function Stat({ label, value, testid }) {
  return (
    <div className="rounded-lg bg-[#f0f2f5] px-3 py-2">
      <div className="text-[11px] uppercase text-[#65676b] font-semibold">{label}</div>
      <div className="font-display text-xl font-extrabold" data-testid={testid}>{value}</div>
    </div>
  );
}

export const ReferralCard = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.referral().then(setR).catch(() => {}); }, []);
  if (!r?.code) return null;
  const link = `${window.location.origin}/register?ref=${r.code}`;
  const copy = () => navigator.clipboard.writeText(link).then(() => toast.success("Lien de parrainage copié"));

  return (
    <section className="card-surface p-6 space-y-4" data-testid="referral-card">
      <div className="flex items-center gap-3">
        <span className="w-10 h-10 rounded-xl bg-[#42b72a] grid place-items-center"><Gift className="w-5 h-5 text-white" /></span>
        <div>
          <h2 className="font-display text-lg font-bold">Parrainage : 5 € par filleul abonné</h2>
          <p className="text-sm text-[#65676b]">Quand votre filleul paie son premier mois, 5 € sont déduits de votre prochaine facture.</p>
        </div>
      </div>
      <div className="flex gap-2">
        <input readOnly value={link} className="flex-1 min-w-0 rounded-lg border border-[#ccd0d5] px-3 py-2 text-sm bg-white" data-testid="referral-link-input" />
        <button type="button" className="btn-primary" onClick={copy} data-testid="referral-copy-btn"><Copy className="w-4 h-4" /> Copier</button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <Stat label="Filleuls" value={r.referrals} testid="referral-count" />
        <Stat label="Abonnés" value={r.subscribed} testid="referral-subscribed" />
        <Stat label="Crédits gagnés" value={eur(r.earned_eur)} testid="referral-earned" />
        <Stat label="En attente" value={eur(r.pending_eur)} testid="referral-pending" />
      </div>
      {r.pending_eur > 0 && <p className="text-xs text-[#65676b]" data-testid="referral-pending-note">Les crédits en attente seront appliqués dès que votre abonnement sera actif.</p>}
    </section>
  );
};
